export const PolicyCancellationReference = "avt_doc_p_canx_default"

export const DocTypeMappings: Record<string, string> = {
  avt_doc_q_default: "Quote Document",
  avt_doc_p_default: "Policy Document",
  [PolicyCancellationReference]: "Policy Cancellation Document"
}

export const supportsDownloadWithoutBreakdown = (
  referenceID?: string
): boolean => !!referenceID && referenceID in DocTypeMappings
